export default __webpack_public_path__ + "static/media/TF_14.925b3660.png";